'use strict';
import angular, { IAttributes, INgModelController, IScope } from 'angular';
import { calculatePasswordStrength } from '@Client/runner.services/password.strength.calculator';
import { UserPasswordStrengthBridge } from './UserPasswordStrengthBridge';

angular.module('flowingly.runner.directives').directive('flowPasswordPolicy', [
  function () {
    return {
      restrict: 'A',
      require: 'ngModel',
      link: function (
        scope: IScope,
        element: JQuery<HTMLElement>,
        attrs: IAttributes,
        ngModel: INgModelController
      ) {
        const validatePassword = function (password: string) {
          const isValid =
            !password || calculatePasswordStrength(password).isAcceptable;
          ngModel.$setValidity('passwordPolicy', isValid);

          return password;
        };

        ngModel.$parsers.unshift(validatePassword);
        ngModel.$formatters.unshift(validatePassword);
      }
    };
  }
]);

angular
  .module('flowingly.runner.directives')
  .component('userPasswordStrength', UserPasswordStrengthBridge);
